import React from 'react';

const SvgIconGenerated = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="M8.002 0c2.138 0 4.147.832 5.658 2.342 3.12 3.12 3.12 8.196 0 11.315A7.957 7.957 0 018 16a7.953 7.953 0 01-5.657-2.342A7.947 7.947 0 010 8c0-2.137.832-4.146 2.344-5.657A7.95 7.95 0 018.002 0zm.025 3.14a.867.867 0 00-.867.858v4.669l.008.099c.045.256.266.453.6.644-.01.009.014.034.06.066l.115.075c.03.018.07.04.125.07l2.746 1.665.105.052c.388.163.8.015 1.02-.367l.047-.096c.159-.393-.035-.862-.427-1.088l-2.666-1.54V4l-.008-.108a.867.867 0 00-.858-.752z" />
  </svg>
);

export default SvgIconGenerated;
